import React, { useEffect, useState } from 'react';
import { useAuth } from '../../../context/Auth';
import { dispatchService } from '../../../services/central-api/dispatch';
import FilterCheckboxList, { FilterListItem } from '../FilterCheckboxList';

interface Props {
    value: number[];
    setValue: React.Dispatch<React.SetStateAction<number[]>>;
    actingBodyId: number;
}

function DispatchUnitNamesList({ value, setValue, actingBodyId }: Props) {
    const [items, setItems] = useState<FilterListItem[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const { user: authenticatedUser } = useAuth();

    function getActingBodyId() {
        if (!authenticatedUser || !authenticatedUser.actingBodyUnit.actingBodyId) {
            return 0;
        }
        return authenticatedUser.isAdmin ? actingBodyId : authenticatedUser.actingBodyUnit.actingBodyId;
    }

    async function getUnitNames() {
        if (getActingBodyId() === 0) {
            setItems([]);
            setIsLoading(false);
            return;
        }
        try {
            setIsLoading(true);
            const unitNames = await dispatchService.getUnitNames(actingBodyId);
            setItems(unitNames.map((role) => ({ value: role.id, label: role.name })));
        } catch (err) {
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        if (!authenticatedUser) {
            return;
        }
        getUnitNames();
    }, [actingBodyId, authenticatedUser]);

    return <FilterCheckboxList items={items} value={value} setValue={setValue} isLoading={isLoading} />;
}

export default DispatchUnitNamesList;
